module.exports = "/feedback_success-56a303be64a107819aab0adaba1e946d.svg";